import { Component, input, signal, computed, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-truncate-review',
  
  template: `
    <p>
      <span>
        {{ trunctedText() }}
      </span>

      @if (this.hasMoreThanLimit() && !showFullText()) {
        <button class="btn btn-link" (click)="showFullText.set(true)">
          Ler mais
        </button>
      }
    </p>
  `,
})
export class TruncateReviewComponent {
  private TEXT_LIMIT = 500;

  text = input.required<string>();

  showFullText = signal(false);

  hasMoreThanLimit = computed(() => this.text().length > this.TEXT_LIMIT);

  trunctedText = computed(() => {
    if (!this.hasMoreThanLimit()) {
      return this.text();
    }

    if (this.showFullText()) {
      return this.text();
    } else {
      return this.text().slice(0, this.TEXT_LIMIT) + '...';
    }
  });
}
